import Vue from "vue";
import "./plugins/polyfill";
import "./plugins/vuetify";
import "./plugins/miment";
import "./plugins/my-vue";
import "./plugins/my-components";
import "./plugins/vue-pin";
import vxios from "./plugins/videoAxios"
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/scss/index.scss";
import VDistpicker from 'v-distpicker'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VueQriously from 'vue-qriously'
Vue.use(VueQriously)
Vue.prototype.$vAxios = vxios
Vue.component('v-distpicker', VDistpicker);
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
